import LandingPage from './landing/LandingPage';
import SEO from '@/components/SEO';

const TITLE =
  'Discloser — The Deal Engine for California Real Estate Agents';
const DESCRIPTION =
  "Discloser reads the packet, answers the buyer's worry, drafts the email between agents, and gets both sides to ready the same afternoon.";

const FAQ_LD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  '@id': 'https://www.discloser.co/#faq-buyer',
  mainEntity: [
    {
      '@type': 'Question',
      name: "How does Discloser help buyer's agents?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Discloser reads the seller's disclosure packet in about 4 minutes and surfaces every red flag with the exact page citation. Buyer's agents walk into the offer already knowing the foundation issue, the deferred maintenance, the easement boundary — and what each item is likely to cost.",
      },
    },
    {
      '@type': 'Question',
      name: 'Does the buyer see the same thing I see?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No. You decide what your buyer sees: full findings + costs, just docs, just a plain-language summary, or any combination. Toggle visibility per category. Revoke instantly. The agent view stays sharp; the buyer view stays calm.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I ask Discloser questions about a specific property?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes. Open Closer chat on any deal and ask anything — fire zone, septic age, easement boundaries, disclosure procedures. Every reply is grounded in the packet with a page citation, not your memory.',
      },
    },
  ],
};

export default function LandingColorBuyer() {
  return (
    <>
      <SEO title={TITLE} description={DESCRIPTION} path="/buyer" jsonLd={FAQ_LD} />
      <LandingPage variant="buyer" />
    </>
  );
}
